"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/useFileDownload.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);


var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _downloadConsent = require('web/services/downloadConsent');
var _DownloadConsentDialog = require('./DownloadConsentDialog'); var _DownloadConsentDialog2 = _interopRequireDefault(_DownloadConsentDialog);

/* Saves a link that storage serves as an attachment (see getFileDownloadLink).
 * In a browser a same-window link to an attachment downloads it and leaves the
 * page alone. In the desktop app the window-open handler downloads it inside
 * the app; following the link in the app window would unload the app. */
 const startDownload = (url) => {
  if (window.ELECTRON) {
    window.open(url, '_blank', 'noopener')
    return
  }
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.rel = 'noopener'
  anchor.style.display = 'none'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
}; exports.startDownload = startDownload

/* Fetches a download link for the file, if the caller may see it, and saves it.
 * Resolves false when there is no link. */
 const downloadFile = async (fileKey) => {
  try {
    const { Link } = await _client2.default.getFileDownloadLink(fileKey)
    if (!Link) return false
    exports.startDownload.call(void 0, Link)
    return true
  } catch (_) {
    return false
  }
}; exports.downloadFile = downloadFile

/* downloadFile, once the user has said they understand the risks
 * (downloadConsent), plus a modal that says so when the download couldn't
 * start. Only the hook that asked shows the question. The question is per
 * user (`userKey`, the viewer). */
const useFileDownload = (userKey) => {
  const [failed, setFailed] = _react.useState.call(void 0, false)
  const [asking, setAsking] = _react.useState.call(void 0, false)
  const ask = _react.useSyncExternalStore.call(void 0, _downloadConsent.downloadConsent.subscribe, _downloadConsent.downloadConsent.current)
  const closeFailure = _react.useCallback.call(void 0, () => setFailed(false), [])
  const download = _react.useCallback.call(void 0, (fileKey) => {
    setFailed(false)
    setAsking(true)
    _downloadConsent.downloadConsent.request(userKey)
      .then((accepted) => {
        setAsking(false)
        if (!accepted) return
        exports.downloadFile.call(void 0, fileKey).then(ok => { if (!ok) setFailed(true) })
      })
      .catch(() => setAsking(false))
  }, [userKey])

  return {
    download,
    downloadNode: (
      _react2.default.createElement(_react2.default.Fragment, null
        , asking && ask && _react2.default.createElement(_DownloadConsentDialog2.default, { onAnswer: _downloadConsent.downloadConsent.answer, __self: this, __source: {fileName: _jsxFileName, lineNumber: 66}} )
        , failed && (
          _react2.default.createElement(_Modal2.default, { isOpen: true, onClose: closeFailure, title: "Download file" , size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}}
            , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}, "We could not download this file. Please try again."        )
            , _react2.default.createElement(_Modal.ModalControls, { primaryBtnLabel: "Close", onPrimaryBtnClick: closeFailure, __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}} )
          )
        )
      )
    ),
  }
}

exports. default = useFileDownload
